import React from 'react';
import SectionCard from './SectionCard';

export default function RestaurantCard({ restaurant, count = 1, onConfigure, onSwitch }) {
  if (!restaurant) return null;
  const subtitleParts = [];
  if (restaurant.ville) subtitleParts.push(restaurant.ville);
  if (restaurant.type_cuisine) subtitleParts.push(restaurant.type_cuisine);

  return (
    <SectionCard
      action={
        <button type="button" onClick={onConfigure} style={styles.configBtn} aria-label="Configurer le restaurant">
          Configurer
        </button>
      }
    >
      <div style={styles.row}>
        <span style={styles.icon} aria-hidden>🏠</span>
        <div style={styles.body}>
          <div style={styles.name}>{restaurant.nom || 'Restaurant'}</div>
          {subtitleParts.length > 0 && (
            <div style={styles.subtitle}>{subtitleParts.join(' · ')}</div>
          )}
        </div>
      </div>
      {count > 1 && (
        <button type="button" onClick={onSwitch} style={styles.switchBtn}>
          {count} restaurants accessibles ›
        </button>
      )}
    </SectionCard>
  );
}

const styles = {
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
  },
  icon: {
    fontSize: 24,
    width: 40,
    height: 40,
    background: '#FFF5F0',
    borderRadius: 12,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  body: {
    flex: 1,
    minWidth: 0,
  },
  name: {
    fontSize: 16,
    fontWeight: 700,
    color: '#1A1A1A',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  subtitle: {
    fontSize: 13,
    color: '#6B6B6B',
    marginTop: 2,
  },
  configBtn: {
    background: 'transparent',
    border: '1px solid #E5E5E0',
    borderRadius: 999,
    padding: '6px 12px',
    fontSize: 13,
    fontWeight: 600,
    color: '#1A1A1A',
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  switchBtn: {
    marginTop: 4,
    background: 'transparent',
    border: 'none',
    color: '#E8502A',
    fontSize: 13,
    fontWeight: 600,
    cursor: 'pointer',
    padding: 4,
    fontFamily: 'inherit',
    textAlign: 'left',
  },
};
